import ProductInfoTooltip from 'lib/components/ProductInfoTooltip/ProductInfoTooltip';
import {
  checkAttendeeLimit,
  PackageNameLabel,
  productFeature,
} from 'lib/utils/productFeature';
import React from 'react';
import { useCreateInstantMeetingMutation } from 'lib/api/meetings/useCreateInstantMeetingMutation';
import { useAuth } from 'lib/context';
import { Button } from 'react-covideo-common';
import { MdVideoCameraFront } from 'react-icons/md';
import { useCurrentAppUrl } from 'lib/hooks/useCurrentAppUrl';
import { useGTMAnalytics } from 'lib/hooks/GTM/useGTMAnalytics';
import { CreateMeetingEventType } from 'lib/hooks/GTM/actions/meeting/types';
import { useTranslation } from 'react-i18next';

export const StartAction = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const { livePageUrl } = useCurrentAppUrl();
  const attendeeLimit = checkAttendeeLimit(userData);
  const { trackGTMCreateMeetingEvent } = useGTMAnalytics();

  const { mutateAsync: createInstantMeetingAsync, isLoading } =
    useCreateInstantMeetingMutation();

  const onStartLiveClick = async () => {
    const meeting = await createInstantMeetingAsync();
    trackGTMCreateMeetingEvent?.({
      meetingResponse: meeting,
      livePageUrl,
      attendeeLimit,
      type: CreateMeetingEventType.START_MEETING,
    });
  };

  return (
    <>
      {userData.hasLiveVideoAccess ? (
        <Button
          text={t('Start Meeting')}
          onClick={onStartLiveClick}
          disabled={!!isLoading}
          icon={<MdVideoCameraFront size={17} />}
          variant='primary'
        />
      ) : (
        <ProductInfoTooltip
          productFeatureId={productFeature.LIVE_VIDEO}
          nextPlan={PackageNameLabel.TEAMS}
          style={{
            left: '0px',
            top: '45px',
          }}
        >
          <Button
            text={t('Start Meeting')}
            disabled
            icon={<MdVideoCameraFront size={17} />}
            variant='primary'
          />
        </ProductInfoTooltip>
      )}
    </>
  );
};
